import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  loadFile,
  loadProblem,
} from 'reducers/async';

import styles from './style';

export default class Load extends Component {
  static propTypes = {
    // state props
    isLoading: PropTypes.bool.isRequired,
    // dispatch props
    loadEnd: PropTypes.func.isRequired,
    loadFail: PropTypes.func.isRequired,
    loadStart: PropTypes.func.isRequired,
  }


  /* local state */

  state = {
    file: null,
    filename: '',
  };


  /* event handlers */

  changeHandler = event => {
    if (event.target.value !== '') {
      event.persist();
      document.getElementById('loadMenu').style.display = 'none';
      this.props.loadStart();
      loadFile(event.target.files[0], this.state)
      .then(response => {
        // document.getElementById('reload').style.display = 'block';
        this.props.loadEnd(response, event.target.files[0].name);
        this.setState({
          file: response,
          filename: event.target.files[0].name,
        });
      })
      .catch(error => {
        // document.getElementById('reload').style.display = 'none';
        this.props.loadFail(error);
      });
    // } else {
    //   document.getElementById('reload').style.display = 'none';
    }
  }

  loadClickHandler = () => {
    if (document.getElementById('loadMenu').style.display === 'none'
    || document.getElementById('loadMenu').style.display === '') {
      document.getElementById('loadMenu').style.display = 'block';
    } else {
      document.getElementById('loadMenu').style.display = 'none';
    }
  }

  mouseDownHandler = filename => {
    document.getElementById('loadMenu').style.display = 'none';
    this.props.loadStart();
    console.log(this.state);
    loadProblem(filename, this.state)
    .then(response => {
      // document.getElementById('reload').style.display = 'block';
      this.props.loadEnd(response, filename);
      this.setState({
        file: response,
        filename,
      });
    })
    .catch(error => {
      // document.getElementById('reload').style.display = 'none';
      this.props.loadFail(error);
    });
  }

  reloadClickHandler = () => {
    document.getElementById('loadMenu').style.display = 'none';
    this.props.loadStart();
    this.props.loadEnd(this.state.file, this.state.filename);
  }


  render() {
    return (
      <div>
        <div className={styles['load-buttons']}>
          <button onClick={this.loadClickHandler} disabled={this.props.isLoading}>
            Load
          </button>
          {/* <button id="reload" className={styles['reload']} onClick={this.reloadClickHandler}>
            <span>{this.state.filename}</span>
            <div className={styles['tooltip']}>{this.state.filename}</div>
          </button> */}
        </div>
        <div id="loadMenu" className={styles['menu']} tabIndex="-1">
          <input type="file" id="file" accept=".xml" onChange={e => this.changeHandler(e)} />
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('requiresGAC.xml')}>
            Requires GAC
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('requires2wC.xml')}>
            Requires 2wC
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('requires3wC.xml')}>
            Requires 3wC
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('requires4wC.xml')}>
            Requires 4wC
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('requiresBackbone.xml')}>
            Requires Backbone
          </div>
          {/* <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test1.xml')}>
            test1
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test2.xml')}>
            test2
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test3.xml')}>
            test3
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test4.xml')}>
            test4
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test5.xml')}>
            test5
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test6.xml')}>
            test6
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test7.xml')}>
            test7
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test8.xml')}>
            test8
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test9.xml')}>
            test9
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test10.xml')}>
            test10
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test11.xml')}>
            test11
          </div>
          <div className={styles['menu-item']} onMouseDown={() => this.mouseDownHandler('test12.xml')}>
            test12
          </div> */}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/general_panel/Load.jsx